export default "__VITE_ASSET__5a512648__"